import { render } from "./subAccount.vue?vue&type=template&id=18c40df7&scoped=true"
import script from "./subAccount.vue?vue&type=script&lang=js"
export * from "./subAccount.vue?vue&type=script&lang=js"

import "./subAccount.vue?vue&type=style&index=0&id=18c40df7&lang=scss"
import "./subAccount.vue?vue&type=style&index=1&id=18c40df7&lang=scss&scoped=true"

import exportComponent from "/Users/a/Desktop/app/boyuan_pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18c40df7"]])

export default __exports__